"use client";

import React from "react";
import { Form, FormControl, InputGroup } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import { useFormik } from "formik";
import * as Yup from "yup";

interface ArticlesCategoriesFilterProps {
    onSearchFilter: (search: string) => void;
}

const ArticlesSearchFilter = ({ onSearchFilter }: ArticlesCategoriesFilterProps) => {
    const formik = useFormik({
        initialValues: {
            search: "",
        },
        validationSchema: Yup.object({
            search: Yup.string().max(200),
        }),
        onSubmit: async (values) => {
            onSearchFilter(values.search);
        },
    });

    return (
        <Form onSubmit={formik.handleSubmit}>
            <InputGroup>
                <FormControl
                    value={formik.values.search}
                    onBlur={formik.handleBlur}
                    name="search"
                    onChange={formik.handleChange}
                    type="text"
                    placeholder="Cauta ..."
                />
                <button type="submit" className="input-group-text">
                    <FaSearch />
                </button>
            </InputGroup>
        </Form>
    );
};

export default ArticlesSearchFilter;
